import { OrderCostDisplayValueTag } from '../../../types/orders';
import { PalletteProps } from '../../../types/theme/pallette';
import styled from 'styled-components';
import { getOrderDisplayColor } from '../../../utils/getOrderDisplayTagColor';
import { rgba } from 'polished';
interface CustomProps extends PalletteProps {
  isLarge: boolean;
}
interface DisplayStatusProps {
  displayStatus?: OrderCostDisplayValueTag;
}

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme, isLarge }: CustomProps) =>
    isLarge ? 'transparent' : theme.white};
  padding: ${({ isLarge }: CustomProps) => (isLarge ? 'none' : '48px 70px')};
  border-radius: 5px;
  box-shadow: ${({ isLarge }: CustomProps) =>
    isLarge ? 'none' : '0px 0px 50px rgba(200, 200, 200, 0.2);'};
  gap: 10px;
  .extraClass {
    width: 350px;
    padding: 20px;
    line-height: 1.5em;
    font-size: 14px !important;
    pointer-events: auto !important;
    max-width: calc(100vw - 20px) !important;
    word-wrap: break-word !important;
    overflow-wrap: break-word !important;
    box-sizing: border-box !important;
    border-radius: 10px;
    &:hover {
      opacity: 1 !important;
    }
    
    @media (max-width: 768px) {
      width: 280px !important;
      padding: 20px !important;
      font-size: 13px !important;
      line-height: 1.4em !important;
      max-width: calc(100vw - 70px) !important;
      left: 20px !important;
      right: 20px !important;
    }
    
    @media (max-width: 480px) {
      width: calc(100vw - 20px) !important;
      padding: 15px !important;
    }
  }
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Subtotal = styled.p`
  color: ${({ theme }: PalletteProps) => theme.black};
  font-size: 1.125rem;
  font-weight: 500;
`;

export const CostItem = styled.p`
  color: ${({ theme }: PalletteProps) => theme.middleGray};
  font-size: 1rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const TotalItem = styled.p`
  color: ${({ theme }: PalletteProps) => theme.darkGray};
  font-size: 1.25rem;
  font-weight: 700;
  margin-top: 38px;
`;

export const DisplayValue = styled.p<DisplayStatusProps>`
  color: ${({ displayStatus, theme }) => displayStatus ? getOrderDisplayColor(displayStatus, theme) : theme.middleGray};
  background-color: ${({ displayStatus, theme }) => displayStatus ? rgba(getOrderDisplayColor(displayStatus, theme), 0.18) : 'transparent'};
  padding: ${({ displayStatus }) => displayStatus ? '3px 9px 4px 9px' : '0'};
  border-radius:${({ displayStatus }) => displayStatus ? '5px' : '0'};
  margin-right: ${({ displayStatus }) => displayStatus ? '-9px' : '0'};
  color: ${({ displayStatus, theme }) => displayStatus ? getOrderDisplayColor(displayStatus, theme) : ''};
  background-color: ${({ displayStatus, theme }) => displayStatus ? rgba(getOrderDisplayColor(displayStatus, theme), 0.18) : ''};
  padding: ${({ displayStatus }) => displayStatus ? '3px 9px 4px 9px' : ''};
  border-radius:${({ displayStatus }) => displayStatus ? '5px' : ''};
  margin-right: ${({ displayStatus }) => displayStatus ? '-9px' : ''};
`;

export const HelpIcon = styled.button`
  color: ${({ theme }: PalletteProps) => theme.middleGray};
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  background: none;
  width: 16px;
  padding: 0;
  margin-left: -5px;
  margin-top: -5px;
  
  &:hover {
    color: ${({ theme }: PalletteProps) => theme.darkGray};
    transform: scale(1.1);
  }
  
  @media (max-width: 768px) {
    width: 14px;
  }
`;
